
export const REJECTION_REASONS = [
  "Not qualified for the role",
  "Salary expectations too high", 
  "Poor communication skills",
  "Lack of required experience",
  "Cultural fit concerns",
  "Failed technical assessment",
  "References didn't check out",
  "Candidate withdrew",
  "Position filled by another candidate",
  "Overqualified for the position",
  "Other"
] as const;

export type RejectionReason = typeof REJECTION_REASONS[number];
